import { Company, Request, User } from "./types"

export enum ActionType {
    SET_COMPANY = 'setCompany',
    SET_COMPANY_LOGO_URL = 'setCompanyLogoUrl',
    SET_USER = 'setUser',
    UPDATE_REQUESTS = 'updateRequests',
    SET_USER_REQUEST = 'setUserRequest',
    UPDATE_COMPANY_USERS = 'updateCompanyUsers'
}

interface SetCompany {
    type: ActionType.SET_COMPANY
    payload: Company
}

interface SetCompanyLogoUrl {
    type: ActionType.SET_COMPANY_LOGO_URL
    payload: string
}

interface SetUser {
    type: ActionType.SET_USER
    payload: User
}

interface UpdateRequests {
    type: ActionType.UPDATE_REQUESTS
    payload: Request[]
}

interface SetUserRequest {
    type: ActionType.SET_USER_REQUEST
    payload?: Request
}

interface UpdateCompanyUsers {
    type: ActionType.UPDATE_COMPANY_USERS
    payload: User[]
}

export type SystemAction =
    SetCompany |
    SetCompanyLogoUrl |
    SetUser |
    SetUserRequest |
    SystemUpdateAction

export type SystemUpdateAction =
    UpdateRequests |
    UpdateCompanyUsers
